import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgClaimProcConfigs,
  createOrgClaimProcConfig,
  updateOrgClaimProcConfig,
  deleteOrgClaimProcConfig,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgClaimProcConfigsRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_CLAIM_PROC_CONFIGS_REQUEST);
    try {
      var response = yield call(getOrgClaimProcConfigs, request.payload);
      yield put(actions.getOrgClaimProcConfigsSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgClaimProcConfigsFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgClaimProcConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_CLAIM_PROC_CONFIG_REQUEST);
    try {
      var response = yield call(createOrgClaimProcConfig, request.payload);
      yield put(actions.createOrgClaimProcConfigSuccess(response.data));
      yield put(actions.getOrgClaimProcConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.createOrgClaimProcConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgClaimProcConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_CLAIM_PROC_CONFIG_REQUEST);
    try {
      var response = yield call(updateOrgClaimProcConfig, request.payload.guid, request.payload);
      yield put(actions.updateOrgClaimProcConfigSuccess(response.data));
      yield put(actions.getOrgClaimProcConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.updateOrgClaimProcConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgClaimProcConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_CLAIM_PROC_CONFIG_REQUEST);
    try {
      yield call(deleteOrgClaimProcConfig, request.payload.guid);
      yield put(actions.deleteOrgClaimProcConfigSuccess(request.payload.guid));
      yield put(actions.getOrgClaimProcConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.deleteOrgClaimProcConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
